import React from 'react';
import { domainColor } from '../utils/domains';

/**
 * A small colored pill badge showing a domain name.
 *
 * Props:
 *   domain {string}  — domain name e.g. "Fury"
 *   short  {boolean} — if true, show only first letter (default false)
 */
const DomainBadge = ({ domain, short = false }) => {
  const color = domainColor(domain);

  return (
    <span
      style={{
        backgroundColor: color + '33',   // 20% opacity fill
        borderColor: color,
        color: color,
      }}
      className="inline-flex items-center justify-center rounded-full border text-xs font-semibold px-2 py-0.5 leading-none"
      title={domain}
    >
      {short ? (domain || '?').charAt(0).toUpperCase() : (domain || '?')}
    </span>
  );
};

export default DomainBadge;
